import React, { useEffect, useRef, useState } from 'react';
import './Pricing.css';

const Pricing = ({ onOpenModal }) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const offers = [
    {
      description: "Valider une idée et explorer un premier cas d'usage IA",
      price: "900 €",
      included: [
        "Audit rapide du besoin",
        "Développement POC fonctionnel",
        "Intégration IA simple",
        "Interface basique web",
        "Livraison rapide"
      ],
      premium: false
    },
    {
      description: "Une solution complète, exploitable en entreprise",
      price: "2 500 €",
      included: [
        "Audit approfondi & cadrage",
        "Solution IA sur mesure",
        "Agent IA avancé",
        "Interface web complète",
        "Déploiement & sécurité",
        "Documentation & suivi"
      ],
      premium: true
    }
  ];

  return (
    <section id="pricing" className={`pricing ${isVisible ? 'visible' : ''}`} ref={sectionRef}>
      <div className="pricing-container">
        <h2 className="pricing-title">
          Mes <span className="highlight-offres">offres</span> sur mesure<br />pour des solutions clés en main.
        </h2>
        
        <div className="pricing-grid">
          {offers.map((offer, index) => (
            <div 
              key={index} 
              className={`pricing-card ${offer.premium ? 'premium' : ''} fade-in-up ${isVisible ? 'visible' : ''}`}
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <p className="offer-description">{offer.description}</p>

              <div className="pricing-header">
                <div className="price-section">
                  <span className="price-label">À partir de</span>
                  <div className="offer-price">{offer.price}</div>
                </div>
                <button onClick={onOpenModal} className="pricing-cta-inline">
                  En savoir plus
                </button>
              </div>

              <div className="pricing-content">
                <ul className="pricing-list-compact">
                  {offer.included.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Section Questions */}
        <div className="pricing-questions">
          <h3 className="questions-title">Des questions ?</h3>
          <p className="questions-description">
            Je sais que prendre une décision sur un projet tech n'est pas toujours simple. 
            Votre besoin n'est peut-être pas encore totalement défini, ou vous souhaitez 
            simplement valider une intuition. Je suis là pour ça : échanger, clarifier, orienter.
          </p>
          <button onClick={onOpenModal} className="questions-cta">
            <img src="/photo/equipe/photo-cv-entier.png" alt="" className="questions-cta-avatar" />
            <span className="button-text">
              <span className="text-default">Réserver un appel</span>
              <span className="text-hover">On est partis ?</span>
            </span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
